import api2 from './api-v2';

const get = async (filter) => {
    const client = await api2.getClient();
    const response = await client.get('deployment-releases', { params: filter });
    return api2.handleSuccess(response);
};

const getById = async ({ id }) => {
    const client = await api2.getClient();
    const app = await client.get(`deployment-releases/${id}`);
    return api2.handleSuccess(app);
};



export default {
    get,
    getById
};
